import { css, cx } from '@linaria/core'
import { BodyText, Button, ButtonGroup, elFlex1, elHFull, elMt8, FlexContainer } from '@reapit/elements'
import { DialogWrapper } from '@reapitform/common-ui'
import { InputTextSignature } from '@reapitform/dashboard-ui'
import { useSignAndCompleteAgreement } from '../../api/documents/actions/sign-and-complete'
import React from 'react'
import { useOrganizationContact } from '../../hooks/use-orgazination-contact'

interface ISignAndCompleteProps {
  isOpen?: boolean
  onClose?: () => void
  onFinish?: (agreementIds: string[]) => void
  agreementId?: string[]
}

export const SignAndCompleteModal: React.FC<ISignAndCompleteProps> = ({
  isOpen = false,
  onClose,
  onFinish,
  agreementId,
}) => {
  const { completeAgreement, isLoading } = useSignAndCompleteAgreement()
  const organizationData = useOrganizationContact()

  const confirmationMessage: string = React.useMemo(() => {
    if (!agreementId?.length) return ''
    const agreementLength: number = agreementId.length
    const isHaveMoreThan1: boolean = Boolean(agreementLength && agreementId.length > 1)

    if (isHaveMoreThan1)
      return `You have selected ${agreementLength} agreements. By proceeding, you consent to having your name used as a digital signature, which will be applied to the lease. The finalised agreement will be sent to both owners and tenants for their records.`
    return 'By proceeding, you consent to using your name as a digital signature, which will be applied to the lease agreement. Both owners and tenants will receive a copy for their records.'
  }, [agreementId?.length])

  if (!agreementId || !agreementId.length) return

  const fullName = `${organizationData?.firstName} ${organizationData?.lastName}`

  const handleCompleteAgreement = async () => {
    await completeAgreement({ iDs: agreementId })
    onFinish?.(agreementId)
    onClose?.()
  }

  return (
    <DialogWrapper handlerModalClose={() => onClose?.()} isModalOpen={isOpen} title="Sign and Complete">
      <FlexContainer isFlexColumn className={cx(elHFull, elFlex1)}>
        <BodyText hasSectionMargin>{confirmationMessage}</BodyText>
        <InputTextSignature
          className={css`
            padding: 1rem !important;
          `}
          label="Preview"
          value={fullName}
        />
        <ButtonGroup alignment="right" className={cx(elMt8)}>
          <Button intent="default" disabled={isLoading} onClick={onClose}>
            Cancel
          </Button>
          <Button loading={isLoading} disabled={isLoading} intent="primary" onClick={handleCompleteAgreement}>
            Complete
          </Button>
        </ButtonGroup>
      </FlexContainer>
    </DialogWrapper>
  )
}
